import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Navigation } from "./navigation";
import { SEO } from "./SEO";

const Layout: React.FC = () => {
    const [showHeader, setShowHeader] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            // Hide header when scrolling down past 100px; otherwise show it
            if (currentScrollY > lastScrollY && currentScrollY > 100) {
                setShowHeader(false);
            } else {
                setShowHeader(true);
            }
            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);

    return (
        <>
            <SEO />
            {/* Pass header visibility state to Navigation */}
            <Navigation locale="es" setLocale={() => { }} showHeader={showHeader} />
            {/* Site wrapper with max width */}
            <div style={{ 
                maxWidth: '100%', 
                margin: '0 auto', 
                backgroundColor: 'white !important',
                width: '100%',
                boxShadow: '0 0 20px rgba(0,0,0,0.1)',
                overflowX: 'hidden',
                overflowY: 'visible'
            }}>
                {/* Adjust margin/padding so content isn't hidden behind the fixed header */}
                <div style={{ paddingTop: "80px" }}>
                    <Outlet />
                </div>
            </div>
        </>
    );
};

export default Layout;